(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sealioo-help-center"] && !Shopify.designMode) return;
  try {
    
(() => {
 const connect = root => {
  for(const center of root.querySelectorAll('[data-help-center]')) {
   const input=center.querySelector('[data-help-search]');
   if(!input||input.dataset.connected)continue;
   input.dataset.connected='true';
   const clean=value=>value.toLocaleLowerCase('sv').normalize('NFD').replace(/[\u0300-\u036f]/g,'');
   input.addEventListener('input',()=>{
    const words=clean(input.value.trim()).split(/\s+/).filter(Boolean);
    let hits=0;
    for(const group of center.querySelectorAll('[data-help-category]')) {
     let matches=0;
     for(const question of group.querySelectorAll('[data-help-question]')) {
      const match=words.every(word=>clean(question.textContent).includes(word));
      question.hidden=!match;
      if(match)matches++;
     }
     group.hidden=matches===0;hits+=matches;
    }
    center.querySelector('[data-help-empty]').hidden=hits>0;
   });
  }
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>connect(document));else connect(document);
 document.addEventListener('shopify:section:load',event=>connect(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
